import { useAuth } from '@/contexts/AuthContext';

// Checa se o usuario logado tem uma permissao RBAC. Admin tem todas
// (mesmo padrao do guard backend). Sem usuario logado, retorna false.
//
// Defensiva: backend pode ocasionalmente retornar permissions undefined em
// estados de race; tratamos como array vazio pra evitar crash.
export function usePermission(perm: string): boolean {
  const { user } = useAuth();
  if (!user) return false;
  if (user.isAdmin) return true;
  const perms = Array.isArray(user.permissions) ? user.permissions : [];
  return perms.includes(perm);
}

// Variante: checa se tem alguma das permissoes da lista. Util pra paginas
// que sao acessiveis com qualquer permissao de um modulo.
export function useAnyPermission(perms: string[]): boolean {
  const { user } = useAuth();
  if (!user) return false;
  if (user.isAdmin) return true;
  const have = Array.isArray(user.permissions) ? user.permissions : [];
  return perms.some((p) => have.includes(p));
}
